/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

import { BreadCrumb, Paragraph, Title } from '@components/atoms'
import { Select } from '@components/atoms/SelectBase/Select'
import {
	RankingStyles,
	ImageIcon,
	ItemName,
	ItemPoints,
	ItemRank,
	ItemTable,
	Rank,
	Podium,
	Position,
	Bench,
	BenchIcon,
	AvatarDefault,
} from '@components/organisms/Ranking/style'
import { ListRankingResponse } from '@models/ranking.model'
import * as Avatar from '@radix-ui/react-avatar'
import { rankingAPI } from '@services/RankingAPI'

import { stylesSimulateRanking } from './styles'

const { titleBox } = stylesSimulateRanking
const { container, title, table } = RankingStyles

export const SimulateRanking = () => {
	const onErrorImg = (event: React.SyntheticEvent<HTMLImageElement, Event>) => {
		const elementoImagem = event.target as HTMLImageElement

		elementoImagem.src = 'https://via.placeholder.com/40'
	}

	const [data, setData] = useState<ListRankingResponse>()

	const [limit, setLimit] = useState<{
		value?: string | number
		option?: string
	}>({
		value: 10,
		option: '10',
	})

	const [
		getRankingSimulated,
		{ data: dataRankingSimulated, isSuccess: isSuccessRankingSimulated },
	] = rankingAPI.useGetMutation()

	const { id } = useParams()

	useEffect(() => {
		if (id) {
			getRankingSimulated({
				id: Number(id),
				page: 1,
				limit: limit.value,
			})
		}
	}, [id, limit])

	useEffect(() => {
		if (isSuccessRankingSimulated) {
			setData(dataRankingSimulated)
		}
	}, [isSuccessRankingSimulated])
	const orderRankingShow = [
		{ order: 1, position: 'second' },
		{ order: 0, position: 'first' },
		{ order: 2, position: 'third' },
	]

	return (
		<div className={container()}>
			<div>
				<BreadCrumb
					buttonReturn
					locations={[
						{ name: 'Simulados', link: '/simulados' },
						{
							name: data?.mockCategory[0].name || '',
							link: `/simulados/prova/${data?.mockCategory[0].id}`,
						},
						{ name: 'Prova', link: `/simulados/prova/${id}` },
						{ name: 'Ranking', link: '' },
					]}
				/>
				<div className={title()}>
					<Title variant='h1' color='$neutral160'>
						Ranking
					</Title>
					<div className={titleBox()}>
						<Select
							placeholder='Número de posições'
							onChange={setLimit}
							options={[
								{ value: 10, option: '10' },
								{ value: 30, option: '30' },
								{ value: 50, option: '50' },
								{ value: 100, option: '100' },
							]}
							css={{ maxWidth: '217px' }}
						/>
					</div>
				</div>

				{data?.data && data.data.length > 2 && (
					<Rank>
						{orderRankingShow.map(({ position, order }, index) => {
							const findIndividual = data?.data[order]

							return (
								findIndividual && (
									<Podium key={index}>
										<Position>
											<Avatar.Root>
												<Avatar.AvatarImage
													src={findIndividual?.photoUrl || ''}
													alt={findIndividual?.name || ''}
													className={RankingStyles.itemImageNew()}
													onError={onErrorImg}
												/>
												<Avatar.AvatarFallback>
													<AvatarDefault>
														<p className='charAtName'>
															{findIndividual?.name.charAt(0).toUpperCase()}
														</p>
													</AvatarDefault>
												</Avatar.AvatarFallback>
											</Avatar.Root>
											<Paragraph
												paragraphType='p2'
												css={{ color: '$neutral120' }}
											>
												{findIndividual?.name.split(' ')[0] || ''}
											</Paragraph>
										</Position>
										<Bench
											position={
												position === 'first' ||
												position === 'second' ||
												position === 'third'
													? position
													: 'none'
											}
										>
											<BenchIcon
												title={position}
												name={position}
												width='40'
												height='40'
											/>
										</Bench>
									</Podium>
								)
							)
						})}
					</Rank>
				)}
				<div className={table()}>
					{data?.data && data.data.length > 0 ? (
						data.data.map(
							({ position, photoUrl, name, rank, currentUser }, index) => (
								<ItemTable myRank={currentUser > 0 && true} key={index}>
									<ItemRank>
										{position > 3 && position}
										{position === 1 && (
											<ImageIcon
												title='first'
												name='first'
												width={34}
												height={30}
											/>
										)}
										{position === 2 && (
											<ImageIcon
												title='second'
												name='second'
												width={34}
												height={30}
											/>
										)}
										{position === 3 && (
											<ImageIcon
												title='third'
												name='third'
												width={34}
												height={30}
											/>
										)}
									</ItemRank>
									<Avatar.Root>
										<Avatar.AvatarImage
											src={photoUrl || ''}
											alt={name || ''}
											className={RankingStyles.itemImageNew()}
											onError={onErrorImg}
										/>
										<Avatar.AvatarFallback>
											<AvatarDefault>
												<p className='charAtName'>
													{name.charAt(0).toUpperCase()}
												</p>
											</AvatarDefault>
										</Avatar.AvatarFallback>
									</Avatar.Root>
									<ItemName>{name}</ItemName>
									<ItemPoints>{rank}</ItemPoints>
								</ItemTable>
							)
						)
					) : (
						<p>sem rank disponivel</p>
					)}
				</div>
			</div>
		</div>
	)
}
